import { BookModel } from "../BookModel/BookModel";
import { AppointmentModelCollection } from "./AppointmentModelCollection";
import { CourseTimespanModelCollection } from "../CourseTimespan/CourseTimespanModelCollection";
import { formatDate, formatTime } from "@/utils/datetime";

export class AppointmentModel extends BookModel {
  static dates = ["from", "to"];
  declare from: string;
  declare to: string;

  get basicInfo() {
    return this.from + " - " + this.to;
  }

  static getCollectionClass() {
    return AppointmentModelCollection;
  }

  private getFormatted(prop: string) {
    const value = this.get<Date>(prop);
    return value ? formatDate(value) : null;
  }

  get startTime() {
    const value = this.get<Date>("from");
    return value ? formatTime(value) : null;
  }

  get endTime() {
    const value = this.get<Date>("to");
    return value ? formatTime(value) : null;
  }

  get startDate() {
    return this.getFormatted("from");
  }
  get endDate() {
    return this.getFormatted("to");
  }

  getFormattedValue(placement: string, prop: string) {
    return this.options.translate(`${placement}.${prop}`, {
      startTime: this.startTime,
      endTime: this.endTime,
      startDate: this.startDate,
      endDate: this.endDate,
    });
  }

  getFromToAuto(placement: string) {
    const toDateSeparator = this.options.translate(`date.to_date_separator`);
    const { startDate, endDate, startTime, endTime } = this;
    const isSameDay = startDate === endDate;
    const isSameTime = startTime === endTime;

    const prependToDateSeparator = (str: string | null) => {
      if (!str?.trim()) return "";
      return `${toDateSeparator} ${str}`;
    };

    return this.options.translate(`${placement}.from_to_auto`, {
      fromDate: startDate,
      fromTime: this.startTime,
      toTime: !isSameDay
        ? endTime
        : isSameTime
          ? ""
          : prependToDateSeparator(endTime),
      toDate: isSameDay ? "" : prependToDateSeparator(endDate),
    });
  }

  getTimespans() {
    return this.belongsToMany<CourseTimespanModelCollection>(
      "course_timespans",
      "computedAppointments",
    );
  }
}
